// React and each editor are fetched only for a matching mount point.
export function installReactComponents(registry) {
  const mounted = new Set()
  function mountWithin(container) {
    if (!container.querySelector) return
    for (const [id, loader] of Object.entries(registry)) {
      const node = container.id === id ? container : container.querySelector(`#${id}`)
      if (!node || node.__reactLoading || node.__reactRoot) continue
      node.__reactLoading = true
      Promise.all([loader(), import("./react_mount.jsx")]).then(([component, runtime]) => {
        if (!node.isConnected) return
        const props = JSON.parse(node.dataset.props || "{}")
        node.__reactRoot = runtime.mountReact(component.default, node, props)
        mounted.add(node)
      }).catch(error => {
        console.error(`Unable to load ${id}`, error)
        window.showToast?.("The editor could not load. Please reload the page.", "danger")
      }).finally(() => { node.__reactLoading = false })
    }
  }
  const observer = new MutationObserver(records => {
    for (const node of mounted) {
      if (!node.isConnected) { node.__reactRoot.unmount(); delete node.__reactRoot; mounted.delete(node) }
    }
    records.forEach(record => record.addedNodes.forEach(mountWithin))
  })
  observer.observe(document.documentElement, { childList: true, subtree: true })
  document.addEventListener("turbo:load", () => mountWithin(document))
  document.addEventListener("turbo:before-cache", () => {
    for (const node of mounted) { node.__reactRoot.unmount(); delete node.__reactRoot }
    mounted.clear()
  })
  mountWithin(document)
}
